import { gql } from '__generated__';

export default gql(`
  query GetContactStats($project_id: ID!, $events: [ID!], $search: String, $locales: [Locale!], $contact_types: [ContactType!], $mail_opt_ins: [ID!], $received_messages: [ID!], $will_receive_messages: [ID!], $registration_filters: RegistrationFilters, $order_filters: OrderFilters) {
    project(id: $project_id) {
      id
      participant_stats(events: $events, search: $search, locales: $locales, contact_types: $contact_types, mail_opt_ins: $mail_opt_ins, received_messages: $received_messages, registration_filters: $registration_filters, order_filters: $order_filters, will_receive_messages: $will_receive_messages) {
        participants
      }
    }
  }
`);
